document.addEventListener("DOMContentLoaded", function () {
    (function () {
        "use strict";

        const classNames = {
            active: "is-active",
            table: "[data-table]",
            convert: "convert",
            rawValue: "rawValue",
            inchValue: "inchValue",
            rowSelector: "c-sizing-pages__row-selector"
        };

        const elements = {
            convertButtons: document.querySelectorAll("[data-convert]"),
            cells: document.querySelectorAll(`${classNames.table} td`),
            rowSelector: document.querySelector(`.${classNames.rowSelector}`)
        };

        function initCmInSwitcher() {
            // Prepare cell datasets
            elements.cells.forEach((cell) => {
                const cellContent = cell.innerHTML.trim();
                cell.dataset[classNames.rawValue] = cellContent;

                const values = cellContent.split(" ");
                for (let i = 0; i < values.length; i++) {
                    if (values[i].endsWith("cm")) {
                        const cmValue = parseFloat(values[i].split("cm")[0]);
                        const inchValue =
                            Math.round((cmValue / 2.54) * 100) / 100 + '"';
                        values[i] = inchValue;
                    }
                }

                cell.dataset[classNames.inchValue] = values.join(" ");
            });

            // Toggle cm / in
            elements.convertButtons.forEach((button) => {
                button.addEventListener("click", () => {
                    if (!button.classList.contains(classNames.active)) {
                        const conversionType = button.dataset[classNames.convert];
                        if (!conversionType) return;

                        // Update active button state
                        elements.convertButtons.forEach((otherButton) => {
                            if (otherButton.dataset[classNames.convert] === conversionType) {
                                otherButton.classList.add(classNames.active);
                            } else {
                                otherButton.classList.remove(classNames.active);
                            }
                        });

                        // Swap the values
                        if (conversionType === "in") {
                            elements.cells.forEach((cell) => {
                                cell.innerHTML = cell.dataset[classNames.inchValue];
                            });
                        } else {
                            elements.cells.forEach((cell) => {
                                cell.innerHTML = cell.dataset[classNames.rawValue];
                            });
                        }
                    }
                });
            });
        }

        function initRowSelector() {
            // Existing “highlight one row” behaviour (for tables that still have the <select>)
            const rowSelectors = document.querySelectorAll(
                `.${classNames.rowSelector}`
            );
            if (!rowSelectors.length) return;

            rowSelectors.forEach((selectorEl) => {
                const tableWrapper = selectorEl.closest(classNames.table);
                if (!tableWrapper) return;

                const rows = tableWrapper.querySelectorAll("tbody tr");

                selectorEl.addEventListener("change", (event) => {
                    const selectedIndex = parseInt(event.target.value, 10);
                    rows.forEach((row, index) => {
                        if (index === selectedIndex) {
                            row.classList.add(classNames.active);
                        } else {
                            row.classList.remove(classNames.active);
                        }
                    });
                });
            });
        }

        // NEW: Tops / Pants toggle
        function initTopPantsTables() {
            // Target only tables that should have the Tops / Pants switch
            const topPantsTables = document.querySelectorAll(
                ".c-sizing-pages__table[data-top-pants='true']"
            );

            topPantsTables.forEach((tableWrapper) => {
                const table = tableWrapper.querySelector("table");
                if (!table) return;

                // Buttons to switch between TOP / PANTS
                const partButtons = tableWrapper.querySelectorAll(
                    "[data-part-toggle]"
                );
                if (!partButtons.length) return;

                // Rows that belong to TOP or PANTS
                const partRows = table.querySelectorAll("[data-part-row]");

                function setPart(part) {
                    // Show/hide rows
                    partRows.forEach((row) => {
                        const rowPart = row.dataset.partRow;
                        if (rowPart === part) {
                            row.style.display = "";
                        } else {
                            row.style.display = "none";
                        }
                    });

                    // Update active button
                    partButtons.forEach((btn) => {
                        if (btn.dataset.partToggle === part) {
                            btn.classList.add(classNames.active);
                        } else {
                            btn.classList.remove(classNames.active);
                        }
                    });
                }

                // Attach listeners
                partButtons.forEach((btn) => {
                    btn.addEventListener("click", () => {
                        const part = btn.dataset.partToggle;
                        if (!part) return;
                        setPart(part);
                    });
                });

                // Initial state: use the button that has .is-active or default to first
                const initialBtn =
                    tableWrapper.querySelector("[data-part-toggle].is-active") ||
                    partButtons[0];
                if (!initialBtn) return;

                setPart(initialBtn.dataset.partToggle);
            });
        }

        function initialize() {
            initCmInSwitcher();
            initRowSelector();
            initTopPantsTables(); // NEW
        }

        initialize();
    })();
});
